import { render, staticRenderFns } from "./LaudoAvaliacaoFundiariasModal.vue?vue&type=template&id=5157b1ac&scoped=true&lang=pug"
import script from "./LaudoAvaliacaoFundiariasModal.vue?vue&type=script&lang=js"
export * from "./LaudoAvaliacaoFundiariasModal.vue?vue&type=script&lang=js"
import style0 from "./LaudoAvaliacaoFundiariasModal.vue?vue&type=style&index=0&id=5157b1ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5157b1ac",
  null
  
)

export default component.exports